import { useEffect, useState, startTransition } from "react";
import { CloseOutlined } from "@ant-design/icons";
import { Modal } from "@mui/material";
import MainBtn from "../main/main_btn/MainBtn";
import { useTranslation } from "react-i18next";
import WiFiConfigurationSteps from "../common/WiFiConfigurationSteps";
import "../home/create_device_modal/style.scss";

type ConfigureWiFiModalProps = {
  open: boolean;
  close: () => void;
  device?: { id: number; name: string };
  titleKey?: string;
  descriptionKey?: string;
  descriptionOptions?: Record<string, string>;
  wifiSsid?: string;
};

const ConfigureWiFiModal = ({
  open = false,
  close = () => null,
  device,
  titleKey = "configure_wifi_modal_title",
  descriptionKey = "configure_wifi_modal_description",
  descriptionOptions,
  wifiSsid,
}: ConfigureWiFiModalProps) => {
  const { t } = useTranslation("home");
  const [currentStep, setCurrentStep] = useState(0);

  const modalTitle = t(titleKey);
  const modalDescription = t(
    descriptionKey,
    descriptionOptions ?? (device ? { deviceName: device.name } : {})
  );

  useEffect(() => {
    if (open) {
      setCurrentStep(0);
    }
  }, [open]);

  const handleNext = () => {
    if (currentStep === 0) {
      startTransition(() => {
        setCurrentStep(1);
      });
    }
  };

  const handleBack = () => {
    if (currentStep > 0) {
      startTransition(() => {
        setCurrentStep(currentStep - 1);
      });
    }
  };

  const handleFinish = () => {
    close();
  };

  return (
    <Modal className="soliseco-modal" open={open} onClose={close}>
      <div className="modal-center">
        <div className="modal-header">
          <div className="close-container" onClick={close}>
            <CloseOutlined />
          </div>
          <span className="title">
            {modalTitle}
          </span>
          <p>
            {modalDescription}
          </p>
        </div>
        <div className="modal-content">
          <WiFiConfigurationSteps
            currentStep={currentStep}
            wifiSsid={wifiSsid}
          />
        </div>
        <div className="modal-footer">
          {currentStep > 0 && (
            <MainBtn
              title={t("wizard_back_btn")}
              color="secondary"
              onClick={handleBack}
            />
          )}
          {currentStep < 1 ? (
            <MainBtn
              title={t("wizard_next_btn")}
              onClick={handleNext}
            />
          ) : (
            <MainBtn
              title={t("wizard_finish_btn")}
              onClick={handleFinish}
            />
          )}
          {currentStep === 0 && (
            <MainBtn title={t("main:cancel")} color="secondary" onClick={close} />
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ConfigureWiFiModal;

